import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import { $mapLoaded } from '../../models/mapModel/index.js';
import { $activeFilters } from '../../models/activeFiltersModel/index.js';
import parking from '../../data/public_parking.json';
import { changeLayerVisibility } from '../../utils/mapbox-utils.js';
import { $isPreset } from '../../models/rbpLiteModel/index.js';

const onClick = (e) => {
  const feature = e.features[0];
  const coordinates = feature.geometry.coordinates.slice();

  const html = `
            <div class="popup_content_wrapper">
              <div class="popup_item_wrapper popup_item_even">
                <div class="popup_item_field">Количество парковочных мест:</div> 
                <div class="popup_item_value">${
                  feature.properties.parking_cnt || '-'
                }</div>
              </div> 
            </div>`;

  new mapboxgl.Popup().setLngLat(coordinates).setHTML(html).addTo(window.map);
};

function PublicParking() {
  const mapLoaded = useUnit($mapLoaded);
  const { chosen_metrics } = useUnit($activeFilters);
  const isPreset = useUnit($isPreset);

  const createLayer = (update) => {
    const parkingData = {
      type: 'FeatureCollection',
      features: parking.features,
    };

    if (update) {
      window.map.getSource('public_parking_source').setData(parkingData);
    } else {
      if (!window.map.getSource('public_parking_source')) {
        window.map.addSource('public_parking_source', {
          type: 'geojson',
          data: parkingData,
        });
      }

      if (!window.map.getLayer('public_parking_layer')) {
        window.map.addLayer({
          id: 'public_parking_bg_layer',
          type: 'circle',
          source: 'public_parking_source',
          paint: {
            'circle-color': 'white',
            'circle-radius': 13,
          },
        });
        window.map.addLayer({
          id: 'public_parking_layer',
          type: 'symbol',
          source: 'public_parking_source',
          layout: {
            'icon-size': 2,
            'icon-image': 'public_parking',
            'icon-allow-overlap': true,
          },
        });
      }

      window.map.on('click', 'public_parking_layer', onClick);

      changeLayerVisibility('public_parking_layer', false);
      changeLayerVisibility('public_parking_bg_layer', false);
    }
  };

  useEffect(() => {
    if (mapLoaded) {
      if (window.map.getLayer('public_parking_layer')) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        }, 500);
      }
    }
  }, [mapLoaded]);

  useEffect(() => {
    if (mapLoaded && window.map.getLayer('public_parking_layer')) {
      if (chosen_metrics[0] === 'parking_place_cnt') {
        changeLayerVisibility('public_parking_layer', true);
        changeLayerVisibility('public_parking_bg_layer', true);

        setTimeout(() => {
          window.map.moveLayer(
            'zoom7_hexagon_layer',
            'public_parking_bg_layer'
          );
          window.map.moveLayer(
            'zoom7_hexagon_outline',
            'public_parking_bg_layer'
          );
        }, 500);
      } else {
        changeLayerVisibility('public_parking_layer', false);
        changeLayerVisibility('public_parking_bg_layer', false);
      }
    }
  }, [mapLoaded, chosen_metrics]);

  useEffect(() => {
    if (mapLoaded && window.map.getLayer('public_parking_layer')) {
      if (isPreset) {
        changeLayerVisibility('public_parking_layer', false);
        changeLayerVisibility('public_parking_bg_layer', false);
      } else if (chosen_metrics[0] === 'parking_place_cnt') {
        changeLayerVisibility('public_parking_layer', true);
        changeLayerVisibility('public_parking_bg_layer', true);

        setTimeout(() => {
          window.map.moveLayer(
            'zoom7_hexagon_layer',
            'public_parking_bg_layer'
          );
          window.map.moveLayer(
            'zoom7_hexagon_outline',
            'public_parking_bg_layer'
          );
        }, 500);
      } else {
        changeLayerVisibility('public_parking_layer', false);
        changeLayerVisibility('public_parking_bg_layer', false);
      }
    }
  }, [mapLoaded, isPreset, chosen_metrics]);

  return null;
}

export default PublicParking;
